module.exports = __webpack_public_path__ + "img/isbn_13_information.48f5249d.jpg";